import useLanguagePaths from 'shared/hooks/useLanguagePaths';
import useTranslation from 'shared/hooks/useTranslation';

import { useRouter } from 'next/router';

export default function useCanonical(): string {
  const { lang } = useTranslation();
  const languagePaths = useLanguagePaths();
  const router = useRouter();

  const basePath = router.pathname;
  const languagePath = languagePaths.paths[lang];

  return `${languagePath}${basePath}`;
}
